/*
 * Vital Pantry - cart add-on offer ("Add a sweet treat")
 *
 * One-click extras, chosen in the theme editor on the "Cart add-on offer"
 * section, shown in the cart drawer and on the cart page just above the
 * subtotal and Check Out.
 *
 * Shopify Basic cannot put anything on the checkout page itself, so this is
 * the last point before checkout an add-on can live.
 *
 * Injected rather than templated, the same way vp-delivery.js does it: the
 * theme re-renders #cart-notification-product and .cart__blocks wholesale, so
 * the offer sits just outside both and survives every re-render.
 */
(function () {
  'use strict';

  var cfg = window.VPAddon;
  if (!cfg || !cfg.products || !cfg.products.length) return;

  // Seeded from Liquid so the offer does not pop in and then hide itself;
  // /cart.js replaces this as soon as it answers.
  var inCart = {};
  (cfg.cart && cfg.cart.variants || []).forEach(function (id) { inCart[id] = true; });
  var hasItems = !!(cfg.cart && cfg.cart.count > 0);

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function build(where) {
    var box = document.createElement('div');
    box.className = 'vpa vpa--' + where;
    box.setAttribute('data-vpa', where);
    box.hidden = true;

    var html = '<p class="vpa__heading">' + escapeHtml(cfg.heading) + '</p>' +
      (cfg.subheading ? '<p class="vpa__sub">' + escapeHtml(cfg.subheading) + '</p>' : '') +
      '<ul class="vpa__list" role="list">';

    cfg.products.forEach(function (p) {
      html +=
        '<li class="vpa__item" data-vpa-variant="' + escapeHtml(p.variant) + '">' +
          (p.image ? '<img class="vpa__img" src="' + escapeHtml(p.image) + '" alt="" width="48" height="48" loading="lazy">' : '') +
          '<span class="vpa__info">' +
            '<a class="vpa__title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
            '<span class="vpa__price">' + escapeHtml(p.price) + '</span>' +
          '</span>' +
          '<button type="button" class="vpa__add" data-vpa-add="' + escapeHtml(p.variant) + '"' +
            ' aria-label="Add ' + escapeHtml(p.title) + ' to cart">Add</button>' +
        '</li>';
    });

    box.innerHTML = html + '</ul><p class="vpa__error" data-vpa-error role="alert" hidden></p>';
    return box;
  }

  /**
   * Drawer: at the bottom of the scrolling item list, outside the form whose
   * contents the theme replaces. #min-cart-items is hidden when the cart is
   * empty, which takes the offer with it.
   *
   * Cart page: directly above the subtotal. .cart__blocks is re-rendered, its
   * parent is not.
   */
  function inject() {
    var items = document.getElementById('min-cart-items');
    if (cfg.drawer && items && !items.querySelector('[data-vpa]')) {
      items.appendChild(build('drawer'));
    }

    var blocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (cfg.cartPage && blocks && !blocks.parentNode.querySelector('[data-vpa]')) {
      blocks.parentNode.insertBefore(build('page'), blocks);
    }
  }

  function render() {
    document.querySelectorAll('[data-vpa]').forEach(function (box) {
      var shown = 0;
      box.querySelectorAll('[data-vpa-variant]').forEach(function (li) {
        li.hidden = !!inCart[li.getAttribute('data-vpa-variant')];
        if (!li.hidden) shown++;
      });
      // An offer next to "Your cart is empty", or with nothing left to offer,
      // is just noise.
      box.hidden = !hasItems || shown === 0;
    });
  }

  function refresh() {
    return fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        inCart = {};
        (c.items || []).forEach(function (it) { inCart[it.variant_id] = true; });
        hasItems = (c.item_count || 0) > 0;
        render();
      })
      .catch(function () { /* keep whatever we last knew */ });
  }

  function add(btn) {
    var id = btn.getAttribute('data-vpa-add');
    var err = btn.closest('[data-vpa]').querySelector('[data-vpa-error]');
    var drawer = document.querySelector('cart-notification');
    // The cart page renders its totals server-side, so there the honest
    // refresh is a reload. The drawer can re-render its own sections.
    var onCartPage = !!document.getElementById('main-cart-items');
    var sections = (!onCartPage && drawer && drawer.getSectionsToRender)
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];

    btn.disabled = true;
    btn.textContent = 'Adding…';
    err.hidden = true;

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(id, 10), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'Sorry, that could not be added.');
          return body;
        });
      })
      .then(function (state) {
        if (onCartPage) {
          window.location.reload();
          return;
        }
        if (drawer && state.sections) {
          // renderContents() only checks item_count for the empty state, and a
          // cart cannot be empty straight after a successful add.
          drawer.renderContents({ sections: state.sections, item_count: 1 });
        }
        inCart[id] = true;
        render();
        btn.disabled = false;
        btn.textContent = 'Add';
      })
      .catch(function (e) {
        err.textContent = e.message;
        err.hidden = false;
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  }

  function init() {
    inject();
    render();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-vpa-add]') : null;
      if (!btn || btn.disabled) return;
      e.preventDefault();
      add(btn);
    });

    // Every add, remove and quantity change ends in the theme replacing one of
    // these, including product-form adds that publish no event at all.
    var timer = null;
    var soon = function () { clearTimeout(timer); timer = setTimeout(refresh, 150); };
    ['cart-notification-product', 'main-cart-items'].forEach(function (elId) {
      var el = document.getElementById(elId);
      if (el && window.MutationObserver) {
        new MutationObserver(soon).observe(el, { childList: true, subtree: true });
      }
    });

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
